// 产品配置数据
const PRODUCT_CONFIGS = {
  AFM201T: {
    breadcrumb: [
      { text: '首页', href: '/', spm: 'sy' },
      { text: '新品推荐', href: '/recommend/list.html', spm: 'xp' },
      { text: '立创首发 | 全新模组，定位IoT智能设备市场，新一代WiFi+蓝牙共存方案', active: true, spm: 'dq' },
    ],
    productInfo: {
      name: 'AFM201T',
      status: '正在供货',
      description: 'WiFi+蓝牙共存模组，ARM Cortex M4内核，100Mhz主频，256K 闪存，2MB flash',
      images: ['//static.szlcsc.com/ecp/assets/web/page/www/xinpinAFM201T/images/Detailedpage_pic_tu_03.gif'],
      datasheet: {
        title: 'AFM201T_datesheet CN1.1',
        url: 'AFM201T_datesheet CN_1.1.pdf',
        downloadFiles: [
          {
            name: 'AFM201T_datesheet CN1.1',
            url: 'AFM201T_datesheet CN_1.1.pdf',
          },
        ],
      },
      activities: [
        {
          title: '评测竞赛',
          link: '#',
          description: '九九物联 | 新一代WiFi+蓝牙共存方案开发板评测活动',
        },
      ],
    },
    rightContent: (
      <div>
        <div className="mb-5 text-center">
          <a href="/brand/11442.html" data-spm="pp">
            <img
              src="//static.szlcsc.com/ecp/assets/web/page/www/xinpinAFM201T/images/jiujiuwulian_01.jpg"
              alt="九九物联"
              className="w-full h-auto mb-2 rounded-lg transition-transform hover:scale-105"
            />
          </a>
          <p className="text-sm leading-relaxed">
            <a
              href="/brand/11442.html"
              target="_blank"
              className="text-blue-500 underline hover:text-blue-600"
              data-spm="tt"
            >
              九九物联提供：整体方案服务、行业成熟固件、开源资料
            </a>
          </p>
        </div>
        <div className="flex gap-2">
          <div className="flex-1 text-center bg-gray-50 p-3 rounded-lg hover:bg-blue-50 hover:-translate-y-1 hover:shadow-md transition-all">
            <img
              src="//static.szlcsc.com/ecp/assets/web/page/www/xinpinAFM201T/images/jiujiuwulian_02.jpg"
              alt=""
              className="w-full h-auto mb-2 rounded"
            />
            <p className="text-xs text-gray-600 leading-tight">定位IoT智能设备市场，新一代WiFi+蓝牙共存方案</p>
          </div>
          <div className="flex-1 text-center bg-gray-50 p-3 rounded-lg hover:bg-blue-50 hover:-translate-y-1 hover:shadow-md transition-all">
            <img
              src="//static.szlcsc.com/ecp/assets/web/page/www/xinpinAFM201T/images/jiujiuwulian_03.jpg"
              alt=""
              className="w-full h-auto mb-2 rounded"
            />
            <p className="text-xs text-gray-600 leading-tight">九九物联（模块+APP+云）整体解决方案和服务</p>
          </div>
        </div>
      </div>
    ),
    tabs: [
      { key: 'features', label: '功能与参数', icon: 'triangle_icon', spm: 'gn' },
      { key: 'docs', label: '技术文档', icon: 'triangle_icon', spm: 'wd' },
      { key: 'tools', label: '工具与软件', icon: 'triangle_icon', spm: 'gj' },
      { key: 'order', label: '立即订购', icon: 'shouppingCar_icon', spm: 'dg' },
      { key: 'support', label: '支持与培训', icon: 'triangle_icon', spm: 'zc' },
      { key: 'activity', label: '活动相关', icon: 'gift_icon', spm: 'hd' },
    ],
    technicalDocs: {
      datasheets: [
        {
          key: '1',
          title: 'AFM201T_datesheet CN1.1',
          type: 'PDF',
          size: '778',
          date: '2019-05-14',
          downloadUrl: 'AFM201T_datesheet CN_1.1.pdf',
        },
      ],
      errata: [
        {
          key: '1',
          title: 'AFM201T_datesheet CN1.1',
          type: 'PDF',
          size: '778',
          date: '2019-05-14',
          downloadUrl: 'AFM201T_datesheet CN_1.1.pdf',
        },
      ],
      applicationNotes: [
        {
          key: '1',
          title: '单片机驱动WiFi架构搭建简述',
          type: 'PDF',
          size: '747',
          date: '2019-03-20',
          downloadUrl: '单片机驱动WiFi架构搭建简述.pdf',
        },
        {
          key: '2',
          title: '九九物联Wi-Fi模块测试工具以及流程',
          type: 'PDF',
          size: '708',
          date: '2018-05-09',
          downloadUrl: '九九物联Wi-Fi模块测试工具以及流程.pdf',
        },
        {
          key: '3',
          title: '九九物联模组生产标准以及焊接建议',
          type: 'PDF',
          size: '353',
          date: '2019-03-26',
          downloadUrl: '九九物联模组生产标准以及焊接建议.pdf',
        },
        {
          key: '4',
          title: 'IoT Wi-Fi 通讯时间',
          type: 'PDF',
          size: '325',
          date: '2018-09-26',
          downloadUrl: 'IoT Wi-Fi 通讯时间.pdf',
        },
        {
          key: '5',
          title: 'AFM201_WiFi+BT封装',
          type: 'PCB',
          size: '296',
          date: '2019-04-25',
          downloadUrl: 'AFM201_WiFi+BT封装.pcb',
        },
      ],
    },
    toolsAndSoftware: {
      designKits: [
        {
          key: '1',
          title: 'AFM201T-EVAL_User manual',
          type: '用户指南',
          size: 'AFM201T',
          date: '',
          downloadUrl: 'AFM201T-EVAL_User_mannual.pdf',
        },
      ],
      software: [
        {
          key: '1',
          title: 'AFM201TAT+ Command（指令集）_V1.1',
          type: '透传软件',
          size: 'AFM201TAT',
          date: '',
          downloadUrl: 'AFM201TAT.pdf',
        },
        {
          key: '2',
          title: 'AFM201T-EVB上手指南',
          type: 'SDK软件',
          size: 'AFM201T-EVB',
          date: '',
          downloadUrl: 'AFM201T-EVB上手指南.docx',
        },
      ],
      devTools: [
        {
          key: '1',
          title: 'AFW121T-EVB 全部资料',
          type: '开发工具全部资料',
          size: '下载链接',
          date: '',
          downloadUrl: 'AFW121T-EVBquanbuziliao.rar',
        },
        {
          key: '2',
          title: 'RTL8720Cx SDK上手指南',
          type: '上手指南',
          size: '点击下载（提取码：99de）',
          date: '',
          downloadUrl: 'https://pan.baidu.com/s/15I8ylMdGbTVT9wh9gXUGtQ',
        },
      ],
    },
    supportAndTraining: {
      support: [
        {
          content: 'AFM201T 技术支持和培训内容',
        },
      ],
      videos: [
        {
          title: 'AFM201T 开发指南',
          description: 'WiFi+蓝牙共存方案开发教程',
          thumbnail: '/images/afm201t-guide.jpg',
          videoUrl: '#',
          duration: '15:20',
        },
      ],
    },
    activities: {
      hasActivities: false,
      overview: null,
      competitions: [],
      creativeContests: [],
    },
    designResources: {
      technicalDocs: [
        {
          type: '用户指南',
          title: 'AFM201T-EVAL_User manual',
          url: 'AFM201T-EVAL_User_mannual.pdf',
          date: '2019-5-22',
        },
      ],
      developmentTools: [
        {
          type: '评估模块和开发板',
          title: 'AFW121T_PCB-制板说明',
          url: 'AFW121T_PCB-zhibanshuoming.xls',
          deviceModel: 'AFW121T-EVB',
        },
        {
          type: '评估模块和开发板',
          title: 'AFW121T-EVAL_0424-PCB文件',
          url: 'AFW121T-EVAL_0424-PCBwenjian.pcb',
          deviceModel: 'AFW121T-EVB',
        },
        {
          type: '评估模块和开发板',
          title: 'AFW121T-EVAL_20190424_sch',
          url: 'AFW121T-EVAL_20190424_sch.pdf',
          deviceModel: 'AFW121T-EVB',
        },
        {
          type: '评估模块和开发板',
          title: 'AFW121T-EVAL_BOM',
          url: 'AFW121T-EVAL_BOM.xls',
          deviceModel: 'AFW121T-EVB',
        },
        {
          type: '评估模块和开发板',
          title: 'AFW121TI-EVAL_20190424.sch',
          url: 'AFW121TI-EVAL_20190424.sch',
          deviceModel: 'AFW121T-EVB',
        },
        {
          type: '评估模块和开发板',
          title: 'gerber_frank 0522',
          url: 'gerber_frank_0522.rar',
          deviceModel: 'AFW121T-EVB',
        },
        {
          type: '评估模块和开发板',
          title: 'AFM201T-EVB 全部资料',
          url: 'AFW121T-EVBquanbuziliao.rar',
          deviceModel: 'AFW121T-EVB',
        },
      ],
      referenceDesigns: [
        {
          title: 'LED照明驱动Wi-Fi模块智能控制照明方案',
          description:
            '本文描述九九物联LED照明驱动Wi-Fi模块智能控制照明方案。通过Wi-Fi模块的引脚对LED照明电源的电流控制，实现亮度调整，色温调整，256色颜色调整，以及灯光动态变化，定时，音乐控制的功能。文中同时描述app设置使用，亚马逊语音控制,google home语音控制，天猫精灵，小米音箱等语音控制功能。',
          image: '//static.szlcsc.com/ecp/assets/web/page/www/xinpinAFM201T/images/jiujiuwulian_05.jpg',
          url: '99iotzhaomingzhineng（BT）kongzhiyonghushoucev1.7 (2).pdf',
        },
      ],
    },
    features: {
      description: [
        'AFM201T是基于Realtek RTL8720C开发的全新模组，定位IoT智能设备市场，是新一代WiFi+蓝牙共存方案。模组按照最优成本设计，技术解决了传统IoT的产品的配网，通讯，以及控制保障的问题。',
        'AFM201T支持802.11b,g,n WiFi通讯，BLE4.2蓝牙配网，控制，并支持WiFi+蓝牙共存，提供优异的板载射频性能，模组包含2路串口，一组SPI，8路PWM输出,3.3V和5V供电，以超高性价比，以及内置多种固件模式给客户提供二次开发。',
      ],
      characteristics: [
        {
          title: '主要性能参数',
          items: [
            'ARM Cortex-M4 处理核心，主频100MHz',
            '3.3V、5V DC 单电源供电',
            '封装：邮票孔 小尺寸：长×宽×厚度 24×15×3.0mmWLAN、Bluetooth 参数',
            '标准：802.11 b/g/n 1x1',
            '发射功率：11b：18dBm / 11g：16dBm / 11n：15dBm',
            '接收灵敏度：11b：-93dBm / 11g：-82dBm / 11n：-76dBm',
            '通信速率：11Mbps @11b / 54Mbps @11g / 150Mbps @11n',
            '工作模式：STA、AP、STA+AP、Buletooth',
            '硬件加密：WPA/WPA2',
            '天线：外接天线，IPEX 天线接口、板载天线',
          ],
        },
        {
          title: '产品特点',
          items: [
            '完整的物联网解决方案(底层开发、云服务、APP)',
            '支持AT+应用集二次开发',
            '支持C-SDK 包的二次开发',
            '支持OTA 无线升级',
            '支持蓝牙智能联网、Airkiss 微信配网功能',
            '工业级应用设计，4 层PCB 设计，性能一致性保证',
            'FCC/CE 认证，符合RoHS 标准',
          ],
        },
        {
          title: '软件特性',
          items: [
            '内置IPV4/IPV6 协议栈',
            '内置FreeRTOS 系统',
            '支持低功耗BLE 4.0',
            '支持HTTP / HTTPS (SSL)加密',
            '支持艾拉云、亚马逊,云、京东云、阿里云',
            '支持定制的私有云或者用户私有云对接',
            '6个FPGA I/O接口 (与树莓派接口共享8个Pin)',
            '支持二次开发，二次整合',
          ],
        },
      ],
      blockDiagram: {
        image: '//static.szlcsc.com/ecp/assets/web/page/www/xinpinAFM201T/images/jiujiuwulian_04.jpg',
        alt: 'AFM201T功能方框图',
        caption: 'AFM201T-功能方框图',
      },
      parametersTable: {
        headers: [
          '商品编码',
          '立即下单',
          '厂家型号',
          'function',
          'Frequency',
          'Sram/ROM',
          'IO',
          'voltage',
          'UART',
          'SPI',
          'PWM (Ch)',
          '功能描述',
          'Kernel',
          'Package',
        ],
        rows: [
          [
            'C398722',
            '立即下单|381190',
            'AFW121TI-EVB',
            'ARM cortex M4+WIFI',
            '62.5Mhz',
            '256K/1M',
            '21PIN',
            '3.3V',
            '1',
            '1',
            '6',
            'Wifi模块AFW121TI开发板',
            'RTL8710BX',
            '36.8x33mm',
          ],
          [
            'C383807',
            '立即下单|357902',
            'AFW121TI-AY1VOC1',
            'ARM cortex M4+WIFI',
            '62.5Mhz',
            '256K/1M',
            '21PIN',
            '3.3V',
            '1',
            '1',
            '6',
            '艾拉云语音方案',
            'RTL8710BX',
            '18x22mm',
          ],
          [
            'C383808',
            '立即下单|357908',
            'AFW121TI-AY1LED1',
            'ARM cortex M4+WIFI',
            '62.5Mhz',
            '256K/1M',
            '21PIN',
            '3.3V',
            '1',
            '1',
            '6',
            '艾拉云灯控方案',
            'RTL8710BX',
            '18x22mm',
          ],
          [
            'C383809',
            '立即下单|357904',
            'AFW121TI-AY1VOC1',
            'ARM cortex M4+WIFI',
            '62.5Mhz',
            '256K/1M',
            '21PIN',
            '3.3V',
            '1',
            '1',
            '6',
            '艾拉云开关方案',
            'RTL8710BX',
            '18x22mm',
          ],
          [
            'C383810',
            '立即下单|357905',
            'AFW121TI-SDK1',
            'ARM cortex M4+WIFI',
            '62.5Mhz',
            '256K/1M',
            '21PIN',
            '3.3V',
            '1',
            '1',
            '6',
            'WiFi开发者学习方案',
            'RTL8710BX',
            '18x22mm',
          ],
          [
            'C383811',
            '立即下单|357906',
            'AFW121TI-POS1',
            'ARM cortex M4+WIFI',
            '62.5Mhz',
            '256K/1M',
            '21PIN',
            '3.3V',
            '1',
            '1',
            '6',
            '扫码支付方案模组',
            'RTL8710BX',
            '18x22mm',
          ],
          [
            'C383812',
            '立即下单|357907',
            'AFW121TI-PRT1',
            'ARM cortex M4+WIFI',
            '62.5Mhz',
            '256K/1M',
            '21PIN',
            '3.3V',
            '1',
            '1',
            '6',
            '微打方案模组',
            'RTL8710BX',
            '18x22mm',
          ],
          [
            'C383813',
            '立即下单|357908',
            'AFW121TI-LED1',
            'ARM cortex M4+WIFI',
            '62.5Mhz',
            '256K/1M',
            '21PIN',
            '3.3V',
            '1',
            '1',
            '6',
            'LED控制卡模组',
            'RTL8710BX',
            '18x22mm',
          ],
          [
            'C383814',
            '立即下单|357909',
            'AFW121TI-HOM1',
            'ARM cortex M4+WIFI',
            '62.5Mhz',
            '256K/1M',
            '21PIN',
            '3.3V',
            '1',
            '1',
            '6',
            '家电mqtt透传',
            'RTL8710BX',
            '18x22mm',
          ],
          [
            'C383815',
            '立即下单|357910',
            'AFW121TI-IND1',
            'ARM cortex M4+WIFI',
            '62.5Mhz',
            '256K/1M',
            '21PIN',
            '3.3V',
            '1',
            '1',
            '6',
            '高可靠性透传模组',
            'RTL8710BX',
            '18x22mm',
          ],
          [
            'C383816',
            '立即下单|357911',
            'AFW121TI-LOW1',
            'ARM cortex M4+WIFI',
            '62.5Mhz',
            '256K/1M',
            '21PIN',
            '3.3V',
            '1',
            '1',
            '6',
            '低功耗应用方案模组',
            'RTL8710BX',
            '18x22mm',
          ],
          [
            'C383817',
            '立即下单|357912',
            'AFW121TI-SPI1',
            'ARM cortex M4+WIFI',
            '62.5Mhz',
            '256K/1M',
            '21PIN',
            '3.3V',
            '1',
            '1',
            '6',
            'SPI通讯方案模组',
            'RTL8710BX',
            '18x22mm',
          ],
          [
            'C383818',
            '立即下单|357913',
            'AFW121TI-WEB1',
            'ARM cortex M4+WIFI',
            '62.5Mhz',
            '256K/1M',
            '21PIN',
            '3.3V',
            '1',
            '1',
            '6',
            'WEB配置方案透传模组',
            'RTL8710BX',
            '18x22mm',
          ],
          [
            'C393817',
            '立即下单|381185',
            'AFM201TI',
            'ARM cortex M4+wifi+ble',
            '100Mhz',
            '256K/2M',
            '23PIN',
            '3.3/5V',
            '2',
            '1',
            '8',
            'WiFi+蓝牙模块',
            'RTL8720CN',
            '15x24mm',
          ],
          [
            'C398723',
            '立即下单|381191',
            'AFM201T-EVB',
            'ARM cortex M4+wifi+ble开发板',
            '100Mhz',
            '256K/2M',
            '23PIN',
            '3.3/5V',
            '2',
            '1',
            '8',
            'WiFi+蓝牙模块开发板',
            'RTL8720CN',
            '36.8x33mm',
          ],
          [
            'C404288',
            '立即下单|391398',
            'AFM201TI-IND2',
            'ARM cortex M4+wifi+ble',
            '100Mhz',
            '256K/2M',
            '23PIN',
            '3.3/5V',
            '2',
            '1',
            '8',
            'WiFi+蓝牙模块指令透传模组',
            'RTL8720CN',
            '15x24mm',
          ],
          [
            'C404289',
            '立即下单|391397',
            'AFM201TI-AY2LED2',
            'ARM cortex M4+wifi+ble',
            '100Mhz',
            '256K/2M',
            '23PIN',
            '3.3/5V',
            '2',
            '1',
            '8',
            'WiFi+蓝牙模块灯控方案模组',
            'RTL8720CN',
            '15x24mm',
          ],
        ],
      },
    },
  },

  GD32E231: {
    breadcrumb: [
      { text: '首页', href: '/', spm: 'sy' },
      { text: '新品推荐', href: '/recommend/list.html', spm: 'xp' },
      { text: '超值MCU! GD32E231系列的工业化部署', active: true, spm: 'dq' },
    ],
    productInfo: {
      name: 'GD32E231',
      status: '正在供货',
      description: '具有 72MHz 频率、64KB 闪存、Arm®Cortex®-M23 32 位 MCU',
      images: [
        '//static.szlcsc.com/ecp/assets/web/page/www/xinpinGD32E231/images/bigShopping1.png',
        '//static.szlcsc.com/ecp/assets/web/page/www/xinpinGD32E231/images/shoping2.jpg',
        '//static.szlcsc.com/ecp/assets/web/page/www/xinpinGD32E231/images/shoping3.jpg',
      ],
      datasheet: {
        title: 'GD32E231 微控制器 数据表 （Rev. 1.0）',
        url: 'GD32E231CxT6_datesheep.pdf',
        downloadFiles: [
          {
            name: 'GD32E231CxT6_datasheet',
            url: 'GD32E231CxT6_datesheep.pdf',
          },
        ],
      },
      activities: [
        {
          title: '开发板Workshop',
          link: 'http://club.szlcsc.com/article/details_38725_1.html',
          description: '兆易创新Arm®Cortex®-M23内核GD32E231开发板评估...',
        },
        {
          title: '创意评选',
          link: 'http://club.szlcsc.com/article/details_38932_1.html',
          description: '谁是最佳脑洞王之GD32E231新运用创意评选活动',
        },
      ],
    },
    rightContent: (wwwTemplateResource = '') => (
      <div>
        <div className="mb-5">
          <div className="mb-2">
            <video controls preload="auto" poster="" className="w-full h-auto rounded-lg shadow-md">
              <source src={`${wwwTemplateResource}/190914_Gigadevice_V2.mp4`} type="video/mp4" />
              <p>您目前的浏览器版本过低，建议下载后观看</p>
            </video>
          </div>
          <p className="text-sm text-center text-gray-600">GD兆易创新MCU产品线介绍</p>
        </div>
        <div className="flex gap-2">
          <div className="flex-1 text-center bg-gray-100 p-3 rounded-md transition-all hover:bg-blue-50 hover:-translate-y-1 hover:shadow-md">
            <a href="/info/12159.html" className="block" data-spm="xydcp">
              <img
                src="//static.szlcsc.com/ecp/assets/web/page/www/xinpinGD32E231/images/GD32E231.jpg"
                alt=""
                className="w-full h-auto mb-2 rounded transition-transform hover:scale-105"
              />
            </a>
            <p className="text-xs text-gray-600 leading-tight">Cortex®-M23内核的新一代产品系列</p>
          </div>
          <div className="flex-1 text-center bg-gray-100 p-3 rounded-md transition-all hover:bg-blue-50 hover:-translate-y-1 hover:shadow-md">
            <a href="/info/12197.html" className="block" data-spm="sgcp">
              <img
                src="//static.szlcsc.com/ecp/assets/web/page/www/xinpinGD32E231/images/GD32E230_new.jpg"
                alt=""
                className="w-full h-auto mb-2 rounded transition-transform hover:scale-105"
              />
            </a>
            <p className="text-xs text-gray-600 leading-tight">Cortex®-M23内核的首个产品系列</p>
          </div>
        </div>
      </div>
    ),
    tabs: [
      { key: 'features', label: '功能与描述', icon: 'triangle_icon', spm: 'gn' },
      { key: 'docs', label: '技术文档', icon: 'triangle_icon', spm: 'wd' },
      { key: 'tools', label: '工具与软件', icon: 'triangle_icon', spm: 'gj' },
      { key: 'order', label: '立即订购', icon: 'shouppingCar_icon', spm: 'dg' },
      { key: 'support', label: '支持与培训', icon: 'triangle_icon', spm: 'zc' },
      { key: 'activity', label: '活动相关', icon: 'gift_icon', spm: 'hd' },
    ],
    technicalDocs: {
      datasheets: [
        {
          key: '1',
          title: 'GD32E231 微控制器 数据表 (Rev. 1.0)',
          type: 'PDF',
          size: '1256',
          date: '2019-03-15',
          downloadUrl: 'GD32E231CxT6_datesheep.pdf',
        },
      ],
      errata: [
        {
          key: '1',
          title: 'GD32E231 微控制器 数据表 (Rev. 1.0)',
          type: 'PDF',
          size: '1256',
          date: '2019-03-15',
          downloadUrl: 'GD32E231CxT6_datesheep.pdf',
        },
      ],
      applicationNotes: [
        {
          key: '1',
          title: 'GPIO_Running_LED',
          type: 'RAR',
          size: '299',
          date: '2019-03-20',
          downloadUrl: 'GPIO_Running_LED_1.rar',
        },
        {
          key: '2',
          title: 'GPIO_Key_Polling_mode',
          type: 'RAR',
          size: '299',
          date: '2019-03-20',
          downloadUrl: 'GPIO_Key_Polling_mode_2.rar',
        },
        {
          key: '3',
          title: 'GPIO_Key_Interrupt_mode',
          type: 'RAR',
          size: '299',
          date: '2019-03-20',
          downloadUrl: 'GPIO_Key_Interrupt_mode_3.rar',
        },
        {
          key: '4',
          title: 'TIMER_Key_EXTI',
          type: 'RAR',
          size: '299',
          date: '2019-03-20',
          downloadUrl: 'TIMER_Key_EXTI_4.rar',
        },
      ],
    },
    toolsAndSoftware: {
      designKits: [
        {
          key: '1',
          title: 'GD32E23x_Demo_Suites_V1.0.0',
          type: '评估模块和开发套件',
          size: 'GD32E231C8T6',
          date: '',
          downloadUrl: 'GD32E23x_Demo_Suites_V1.0.0.rar',
        },
      ],
      software: [
        {
          key: '1',
          title: 'GD32E23x_AddOn',
          type: '软件包',
          size: 'GD32E231C8T6',
          date: '',
          downloadUrl: 'GD32E23x_AddOn.rar',
        },
        {
          key: '2',
          title: 'GD32E23x_Firmware_Library',
          type: '软件包',
          size: 'GD32E231C8T6',
          date: '',
          downloadUrl: 'GD32E23x_Firmware_Library.rar',
        },
      ],
      devTools: [
        {
          key: '1',
          title: 'GD32E231开发工具MDK-Arm',
          type: '开发工具',
          size: '下载链接',
          date: '',
          downloadUrl: 'https://www.keil.com/download/product/',
        },
      ],
    },
    supportAndTraining: {
      support: [
        {
          content: 'GD32E231 技术支持和开发培训',
        },
      ],
      videos: [
        {
          title: 'GD32E231 开发教程',
          description: 'Arm Cortex-M23 内核 MCU 开发指南',
          thumbnail: '/images/gd32e231-tutorial.jpg',
          videoUrl: '#',
          duration: '12:45',
        },
      ],
    },
    activities: {
      hasActivities: true,
      overview: {
        timeline: [
          {
            period: '2019年3月上旬',
            events: ['3月12日，立创新媒体线下采访兆易创新公司', '3月18日，GD32E231的样品立创商城上线'],
            color: 'blue',
          },
          {
            period: '2019年3月下旬',
            events: ['3月20日，兆易创新MCU市场总监金光易应邀参加穆尼黑上海展会立创商城站台现场'],
            color: 'green',
          },
          {
            period: '2019年4月上旬',
            events: ['4月8日，"创意评选" 和 "评测竞赛" 的活动同步上线进行'],
            color: 'purple',
          },
          {
            period: '2019年4月中旬',
            events: ['4月9日，深圳CITE展会现场展示GD32E231开发板'],
            color: 'orange',
          },
          {
            period: '2019年4月下旬',
            events: ['4月18日，工业控制运用元器件低至8折起，且支持 "报价" 服务'],
            color: 'red',
          },
          {
            period: '2019年5月~6月',
            events: ['5月10日，活动揭晓', '6月5日，项目线下见面会'],
            color: 'indigo',
          },
        ],
      },
      competitions: [
        {
          title: 'GD32E231开发板评估测试活动',
          duration: '即日起至2019年5月22号',
          description: '免费领取开发板参与活动',
          link: 'http://club.szlcsc.com/article/details_38725_1.html',
          prizes: [
            { rank: '一等奖', count: '1份', prize: '150元京东E卡', image: 'prize1.jpg' },
            { rank: '二等奖', count: '5份', prize: '移动电源', image: 'prize2.jpg' },
            { rank: '三等奖', count: '10份', prize: '雨伞或U盘', image: 'prize3.jpg' },
          ],
        },
      ],
      creativeContests: [
        {
          title: 'GD32E231新运用创意评选活动',
          duration: '即日起至2019年4月28号',
          description: '只要回帖即可有机会拿88元京东e卡',
          link: 'http://club.szlcsc.com/article/details_38932_1.html',
          prizes: [
            { rank: '一等奖', count: '1份', prize: '80元京东E卡', image: 'prize4.jpg' },
            { rank: '二等奖', count: '3份', prize: '70元商城无门槛优惠券', image: 'prize6.jpg' },
            { rank: '三等奖', count: '5份', prize: '50元商城无门槛优惠券', image: 'prize5.jpg' },
          ],
        },
      ],
    },
    designResources: {
      technicalDocs: [
        {
          type: '用户指南',
          title: 'GD32E23x_User_Manual_EN_Rev1.0',
          url: 'GD32E23x_User_Manual_EN_Rev1.0.pdf',
          date: '2019-03-20',
        },
      ],
      developmentTools: [
        {
          type: '评估模块和开发板',
          title: 'GD32E231C-START原理图',
          url: 'GD32E231C-START-V1.0开发板原理图.pdf',
          deviceModel: 'GD32E231C8T6',
        },
        {
          type: '评估模块和开发板',
          title: 'GD32E231C-START_User_Guide_V1.0',
          url: 'GD32E231C-START_User_Guide_V1.0.pdf',
          deviceModel: 'GD32E231C8T6',
        },
      ],
      referenceDesigns: [
        {
          title: 'BLDC电机控制Demo板',
          description:
            '此板可通过安检实现BLDC电机的操控（模式选择、启停、刹车、切换、转向等）等功能，数码管可显示当前电机转速。',
          image: '//static.szlcsc.com/ecp/assets/web/page/www/xinpinGD32E231/images/controlpanel.jpg',
          url: 'GD32E231C_BLDC控制 Demo板 用户手册-V1.0.pdf',
        },
      ],
    },
    features: {
      description: [
        'GD32E231系列超值型MCU新品以全面优化的处理器资源和最为经济的成本优势，将创新的Arm® Cortex®-M23内核引入高速信号采集、混合信号处理、电机控制、传感器网络等工业应用场合，并持续推动Cortex®-M23内核MCU的工业化部署与全面普及。',
        '为了支持更多信号链应用，还配置了1个高速轨到轨输入/输出模拟电压比较器(COMP)，2个高增益轨到轨运放(OPA)，1个12位2.6M SPS采样率的高性能模数转换器(ADC)，以高集成度简化硬件开发，节省PCB布板空间、从而形成最新的单芯片解决方案并有效降低系统成本。',
      ],
      characteristics: [
        {
          title: '微控制器',
          items: ['4KB~8KB缓存SRAM', '16KB~64KB嵌入式闪存', '高达72MHz运算主频', '封装:7mmx7mm LQFP48'],
        },
        {
          title: '封装:7mmx7mm LQFP48',
          items: [],
        },
        {
          title: '外设',
          items: [
            '5个16位通用定时器，多达20路PWM输出',
            '1个支持三相脉宽调制PWM输出和霍尔采集接口的16位高级矢量控制定时器',
            '1个16位基本定时器和1个多通道DMA控制器',
            '2 个高增益轨到轨运算放大器',
            '2个串行外设接口（SPI）',
            '1 个轨到轨高速模拟比较器',
            '1 个12位SAR ADC@2.6Msps, 10通道',
            '2个通用同步异步收发器（USART）',
            '2个串行外设接口（SPI）',
            '2个I2C',
            '1个I2S',
          ],
        },
        {
          title: '温度',
          items: ['-40ºC到85ºC', '开发工具', 'ARM Keil'],
        },
      ],
      blockDiagram: {
        image: '//static.szlcsc.com/ecp/assets/web/page/www/xinpinGD32E231/images/block_scheme.png',
        alt: 'GD32E231功能方框图',
        caption: 'GD32E231-功能方框图',
      },
      parametersTable: {
        headers: [
          'Part number',
          '立即下单',
          'cpu',
          'Total processing (MIPS)',
          'Frequency (MHz)',
          'Flash (KB)',
          'RAM (KB)',
          'ADC resolution',
          'ADC (Ch)',
          'Comparators (#)',
          'PWM (Ch)',
          'I2C',
          'SPI',
          'UART (SCI)',
          'FPU',
          'Operating temperature range (C)',
          'Features',
          'Analog-to-digital converter (ADC)',
          'GPIO',
          'Package size: mm2:W x L (PKG)',
          'PWM technology type',
          'Temp sensor',
        ],
        rows: [
          [
            'GD32E231C8T6',
            '立即下单|352998',
            'Arm Cortex-M23',
            '80 DMIPS',
            '72',
            '64',
            '8',
            '12 Bits',
            '10',
            '1',
            '20',
            '2',
            '2',
            '2',
            '0',
            '【-40 to +85】',
            '',
            'SAR ADCx1 @2Msps',
            '39',
            '7 x 7mm',
            '',
            '1',
          ],
          [
            'GD32E230F8P6TR',
            '立即下单|352997',
            'Arm Cortex-M23',
            '',
            '72',
            '64',
            '8',
            '12 Bits',
            '9',
            '',
            '',
            '2',
            '2',
            '2',
            '',
            '【-40 to +85】',
            '',
            'SAR ADCx1 @2Msps',
            '',
            '6.5 x 4.4mm',
            '',
            '',
          ],
        ],
      },
    },
  },

  XILINXPYNQZ2: {
    breadcrumb: [
      { text: '首页', href: '/', spm: 'sy' },
      { text: '新品推荐', href: '/recommend/list.html', spm: 'xp' },
      { text: '开源项目新利器！XILINX PYNQ-Z2开源框架的第二代最新开发平台', active: true, spm: 'dq' },
    ],
    productInfo: {
      name: 'PYNQ-Z2',
      status: '正在供货',
      description: '具有650MHz双核Cortex-A9处理器、DDR3，以XC7Z020 FPGA为核心的可嵌入式编程开发板。',
      images: [
        '//static.szlcsc.com/ecp/assets/web/page/www/xinpinXILINXPYNQZ2/images/shailinsichanpingtu01.jpg',
        '//static.szlcsc.com/ecp/assets/web/page/www/xinpinXILINXPYNQZ2/images/shailinsichanpingtu02.jpg',
      ],
      datasheet: {
        title: 'PYNQ-Z2开发板 数据表',
        url: '/PYNQ-Z2_PA_v3.pdf',
        downloadFiles: [
          {
            name: 'PYNQ-Z2_PA_v3',
            url: 'PYNQ-Z2_PA_v3.pdf',
          },
        ],
      },
      activities: [
        {
          title: '评测竞赛',
          link: 'http://club.szlcsc.com/article/details_39687_1.html',
          description: 'XILINX开发板PYNQ-Z2限量免费申请试用活动',
        },
      ],
    },
    rightContent: null, // XILINX 页面没有右侧内容
    tabs: [
      { key: 'features', label: '功能与参数', icon: 'triangle_icon', spm: 'gn' },
      { key: 'docs', label: '技术文档', icon: 'triangle_icon', spm: 'wd' },
      { key: 'tools', label: '工具与软件', icon: 'triangle_icon', spm: 'gj' },
      { key: 'order', label: '立即订购', icon: 'shouppingCar_icon', spm: 'dg' },
      { key: 'support', label: '支持与培训', icon: 'triangle_icon', spm: 'zc' },
      { key: 'activity', label: '活动相关', icon: 'gift_icon', spm: 'hd' },
    ],
    technicalDocs: {
      datasheets: [
        {
          key: '1',
          title: 'PYNQ-Z2_PA_v3',
          type: 'PDF',
          size: '872',
          date: '2018-05-17',
          downloadUrl: 'PYNQ-Z2_PA_v3.pdf',
        },
      ],
      errata: [
        {
          key: '1',
          title: 'PYNQ-Z2_PA_v3.pdf',
          type: 'PDF',
          size: '872',
          date: '2018-05-17',
          downloadUrl: 'PYNQ-Z2_PA_v3.pdf',
        },
      ],
      applicationNotes: [
        {
          key: '1',
          title: 'PYNQ-Z2 Reference Manual v1.0',
          type: 'PDF',
          size: '1434',
          date: '2018-05-17',
          downloadUrl: 'PYNQ-Z2%20Reference%20Manual%20v1.0.pdf',
        },
        {
          key: '2',
          title: 'TUL_PYNQ Schematic_R12',
          type: 'PDF',
          size: '398',
          date: '2018-03-19',
          downloadUrl: 'TUL_PYNQ%20Schematic_R12.pdf',
        },
        {
          key: '3',
          title: 'PYNQ-Z2-AcrylicCaseDrawing',
          type: 'PDF',
          size: '133',
          date: '2018-03-19',
          downloadUrl: 'PYNQ_Z2-AcrylicCaseDrawing.PDF',
        },
      ],
    },
    toolsAndSoftware: {
      designKits: [
        {
          key: '1',
          title: 'PYNQ Z1原厂官方入门指导手册_v2.0',
          type: '开发板',
          size: 'PYNQ-Z1',
          downloadUrl: 'PYNQ Z1原厂官方入门指导手册_v2.0.pdf',
        },
      ],
      software: [
        {
          key: '1',
          title: 'Boot Image V2.4（提取码：9wnj）',
          type: '软件库',
          size: 'PYNQ-Z1',
          downloadUrl: 'https://pan.baidu.com/s/1Pv5ZDh1gQZaGGc7Rdap6zg',
        },
        {
          key: '2',
          title: 'PYNQ-master示例程序',
          type: '软件库',
          size: 'PYNQ-Z1',
          downloadUrl: 'PYNQ-master示例程序.rar',
        },
      ],
      devTools: [],
    },
    supportAndTraining: {
      support: [
        {
          content: 'PYNQ-Z2 Setup Guide 等技术支持内容',
        },
      ],
      videos: [
        {
          title: 'PYNQ-Z2 Setup Guide',
          description: 'Prerequisites, Board Setup instructions and getting started guide',
          thumbnail: '/images/pynq-z2-setup-guide.jpg',
          videoUrl: '#',
          duration: '10:30',
        },
      ],
    },
    activities: {
      hasActivities: true,
      overview: {
        description:
          'XILINX开发板PYNQ-Z2限量免费申请试用活动正在进行中，欢迎广大开发者参与体验这款基于Zynq SoC的开源开发平台。',
      },
      competitions: [
        {
          title: 'XILINX开发板PYNQ-Z2限量免费申请试用活动',
          duration: '即日起止2019年9月10日（最后一批试用板寄出日期截止：8月26日）',
          description: '限量免费申请试用活动',
          link: 'https://jinshuju.net/f/0LANhC',
          qrCode: 'xinpinactivity04.jpg',
          requirements: [
            '扫描二维码，提交申请表格',
            '活动方不定期筛选，累计达到10个试用者后线下通知',
            '试用者缴纳押金500RMB（开发板商城销售价格950RMB）',
            '收到押金后，开机验证试用板，合格后顺丰寄送',
            '试用者收到开发板2个工作日内开机验证',
            '进行学习评估，并在论坛发帖记录试用过程（时限：3周）',
            '提交试用报告并顺丰到付寄回活动方',
          ],
          rewards: [
            {
              type: '项目落地奖励',
              description: '本活动试用开发板+100元*2张 商城无门槛优惠券',
              image: 'xinpinactivity01.jpg',
              requirement:
                '活动方通过线上验收运营报告，并线下沟通确认，该项目须有完整的立项日期，项目规划，样机、小批量、批量时间表和Forecast。',
            },
            {
              type: '试用报告奖励',
              description: '50元*2张 商城无门槛优惠券',
              image: 'xinpinactivity02.jpg',
              requirement: '活动方通过线上验收试用报告，要求内容完整、全面，客观。',
            },
          ],
        },
      ],
      creativeContests: [],
    },
    designResources: {
      technicalDocs: [
        {
          type: '开发板介绍',
          title: 'PYNQ-Z2_PA_v3',
          url: 'PYNQ-Z2_PA_v3.pdf',
          date: '2018-05-17',
        },
      ],
      developmentTools: [
        {
          type: '评估模块和开发板',
          title: 'PYNQ-Z2 Reference Manual v1.0',
          url: 'PYNQ-Z2 Reference Manual v1.0.pdf',
          deviceModel: 'PYNQ-Z2',
        },
        {
          type: '评估模块和开发板',
          title: 'TUL_PYNQ Schematic_R12',
          url: 'TUL_PYNQ Schematic_R12.pdf',
          deviceModel: 'PYNQ-Z2',
        },
        {
          type: '评估模块和开发板',
          title: 'PYNQ_Z2-AcrylicCaseDrawing',
          url: 'PYNQ_Z2-AcrylicCaseDrawing.PDF',
          deviceModel: 'PYNQ-Z2',
        },
      ],
      referenceDesigns: [],
    },
    features: {
      description: [
        'PYNQ-Z2开发板是Xilinx开源框架的第二代最新开发平台，支持PYNQ即Python on ZYNQ。即使用Python语言和库，设计人员可以利用Zynq中可编程逻辑和微处理器的优势来快速构建高性能的嵌入式应用程序，充分发挥Xilinx Zynq SoC的功能。可编程逻辑电路以硬件库的形式导入并且可以通过API编程，这种方式基本上与软件库的导入和编程方式相同。',
        'PYNQ-Z2 开发板以ZYNQ XC7Z020 FPGA为核心，配备有以太网，HDMI输入/输出，MIC输入，音频输出，Arduino接口，树莓派接口，2个Pmod，用户LED，按钮和开关。兼容树莓派连接器、Arduino屏蔽连接器以及Pmod连接器可以支持多种配件拓展，同时这些接口也可以用作GPIO。',
      ],
      characteristics: [
        {
          title: '650MHz双核Cortex-A9处理器',
          items: [],
        },
        {
          title: 'DDR3内存控制器，具有8个DMA通道和4个高性能 AXI3从端口',
          items: [],
        },
        {
          title: '高带宽外设控制器：1G以太网，USB 2.0，SDIO',
          items: [],
        },
        {
          title: '低带宽外设控制器：SPI，UART，CAN，I2C',
          items: [],
        },
        {
          title: '可从JTAG，Quad-SPI闪存和microSD卡进行编程',
          items: [
            'Artix-7系列可编程逻辑',
            '13,300个逻辑片，每个具有四个6输入LUT和8个触发器',
            '630 KB的快速block RAM',
            '4个时钟管理片，每个片都有一个锁相环（PLL）和混合模式时钟管理器（MMCM）',
            '220 DSP切片',
            '片上模数转换器（XADC）',
          ],
        },
      ],
      blockDiagram: {
        image: '//static.szlcsc.com/ecp/assets/web/page/www/xinpinXILINXPYNQZ2/images/xinpin002fkt.png',
        alt: 'PYNQ-Z2功能方框图',
        caption: 'PYNQ-Z2-功能方框图',
      },
    },
  },
};

// 获取产品配置
export const getProductConfig = (productType) => {
  return PRODUCT_CONFIGS[productType] || PRODUCT_CONFIGS.AFM201T;
};
